import CartItem from './CartItem/CartItem';
import styles from './CartItems.module.scss';

function CartItems(props) {

  let items = props.selectedServices;
  if(items){
    items = items.sort((a, b) => {
      if (a.sortOrder < b.sortOrder) {
        return -1;
      }
      if (a.sortOrder > b.sortOrder) {
        return 1;
      }
      return 0;
    });
  }

  return (
    <div className={styles["cart-services-container"]} >
        {items && ( items.map((item, index)=>{
          return(
            <CartItem 
              key={index} 
              item={item}
              selectedServices={props.selectedServices}
              onServiceDeSelect={props.onServiceDeSelect}
            />)
        })) 
        }
    </div>


  );
}

export default CartItems;